module.exports = __webpack_public_path__ + "img/lacrosse-stick-ball.96b23175.svg";